import React, { useState } from "react";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import { DateStringFormat, formatTime } from "../../../shared/helper/helper.service";

const AppointmentBooked = (props) => {
  const { show, handleClose, data, selectedDoctor } = props;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <div className="modal-topview">
        <img src={require("../../../asstes/images/booked.png")} />
        <p>Appointment Booked Successfully</p>
      </div>
      <div className="modal-bodyview">
        <div className="appoiment-details">
          <img src={selectedDoctor?.avatar} />
          <div className="doctor-details">
            <h2>{selectedDoctor?.doctorname || selectedDoctor?.carenavigatorname}</h2>
            {selectedDoctor?.specialization && <h3>{selectedDoctor?.specialization}</h3>}
            <div className="selected-date2">
              <img
                className="calendar-outline"
                src={require("../../../asstes/images/calendar-outline.png")}
              />
              <p> {data?.appointmentDate && DateStringFormat(data?.appointmentDate)}, {data?.appointmentSlot && formatTime(data?.appointmentSlot)}</p>
            </div>
            {selectedDoctor?.clinicAddress &&
            <div className="selected-date2">
              <img
                className="calendar-outline"
                src={require("../../../asstes/images/location.png")}
              />
              <p>{selectedDoctor?.clinicAddress}</p>
            </div>
            }
          </div>
        </div>
        <button className="back-btn" onClick={handleClose}>
          Back to Homepage
        </button>
      </div>
    </Modal>
  );
};

export default AppointmentBooked;
